import { useEffect, useRef, useState } from "react";
import { animate, motion, useInView } from "framer-motion";
import { STATS } from "../data/content";

const CountUp = ({ value, suffix, decimals }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState("0");

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, value, {
      duration: 2,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(decimals ? v.toFixed(decimals) : Math.round(v).toString()),
    });
    return () => controls.stop();
  }, [inView, value, decimals]);

  return (
    <span ref={ref}>
      {display}
      <span className="text-blueprint-accent">{suffix}</span>
    </span>
  );
};

const Stats = () => (
  <section id="stats" data-testid="stats-section" className="relative bg-slate-50 blueprint-grid-fine border-b border-slate-200">
    <span className="absolute top-3 right-4 font-mono text-blueprint/50 select-none" aria-hidden>+</span>
    <span className="absolute bottom-3 left-4 font-mono text-blueprint/50 select-none" aria-hidden>+</span>
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="grid grid-cols-2 lg:grid-cols-4 border border-blueprint-line bg-white">
        {STATS.map((s, i) => (
          <motion.div
            key={s.spec}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: i * 0.1, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`stat-card-${i + 1}`}
            className={`p-7 md:p-10 ${i % 2 === 1 ? "border-l border-blueprint-line" : ""} ${i > 1 ? "border-t lg:border-t-0 border-blueprint-line" : ""} ${i > 0 ? "lg:border-l lg:border-blueprint-line" : ""}`}
          >
            <p className="font-mono text-[9px] tracking-[0.3em] uppercase text-slate-400 mb-4">{s.spec}</p>
            <p data-testid={`stat-value-${i + 1}`} className="font-display font-extrabold tracking-tight text-4xl md:text-5xl text-prussian">
              <CountUp value={s.value} suffix={s.suffix} decimals={s.decimals} />
            </p>
            <p className="mt-3 text-xs md:text-sm text-slate-500">{s.label}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Stats;
